<template>
    <div>
        <base-header type="gray-100" class="pb-6 pb-8 pt-5 pt-md-5">
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                      <div class="card-header border-0">
                        <div class="row align-items-center">
                          <div class="col">
                            <h3 class="mb-0">
                              Executar Pagamento de Solicitações
                            </h3>
                          </div>
                        </div>
                      </div>
                       <div class="text-right p-4">
                         
                       </div>
                      

                      <div class="table-responsive">
                        <template>
                          <base-table class="table align-items-center table-flush"
                                      tbody-classes="list"
                                      :data="listaDados">
                            <template slot="columns">
                            <th>#</th>
                            <th>Laboratório</th>
                            <th>Dentista</th>
                            <th>Paciente</th>
                            <th>Serviços</th>
                            <th class="text-right">Serviço (R$)</th>
                            <th class="text-right">Pago (R$)</th>
                            <th class="text-right">Pendente (R$)</th>
                            <th class="text-center">Data de Execução</th>
                            <th class="text-center">Pagamento</th>
                            </template>

                            <template slot-scope="{row}">
                                <th scope="row">
                                  <span>{{ row.id }}</span>
                                </th>
                                <td>
                                  {{ row.laboratorio.nomeFantasia }}
                                </td>
                                <td>
                                  {{ row.dentista.nome }}
                                </td>
                                <td>
                                  {{ row.paciente }}, {{ row.idade }}
                                </td>
                                <td>
                                    <table class="subtable">
                                      <tr>
                                        <th>Descritivo</th>
                                        <th class="text-right">Valor</th>
                                      </tr>
                                      <tr v-for="(item, index) in agruparServicos(row.servicos)" :key="index">
                                        <td>{{ item.nome }}</td>
                                        <td>
                                          R$ {{ item.valor.toLocaleString('pt-br', {minimumFractionDigits: 2}) }}
                                          <span v-show="item.qtd >= 1" style="font-size: 10px;">(x{{ item.qtd }})</span>
                                        </td>
                                      </tr>
                                    </table>
                                </td>
                                <td class="text-right">
                                  R$ {{ row.valores.toLocaleString('pt-br', {minimumFractionDigits: 2}) }}
                                </td>
                                 <td class="text-right">
                                  R$ {{ row.valor_pago.toLocaleString('pt-br', {minimumFractionDigits: 2}) }}
                                </td>
                                 <td class="text-right">
                                  R$ {{ row.valor_pendente.toLocaleString('pt-br', {minimumFractionDigits: 2}) }}
                                </td>
                                <th class="text-center">
                                  {{ formatarData(row.created_at) }}
                                  </th>
                                
                                <td class="text-center">
                                  <div class="" v-show="row.contabilizar == 1 && row.valor_pago == 0 && row.valor_pendente > 0">
                                    <i class="fas fa-exclamation-circle" style="color: #F44C00;"></i>
                                  </div>
                                  <div class="" v-show="row.contabilizar == 1  && row.valor_pago > 0 && row.valor_pendente > 0">
                                    <i class="fas fa-exclamation-circle" style="color: #F2B705;"></i>
                                  </div>
                                   <div class="" v-show="row.contabilizar == 1 && row.valor_pago == row.valores">
                                    <i class="fas fa-check-circle" style="color: green;"></i>
                                  </div>
                                  <div class="" v-show="row.contabilizar == 1 && row.arquivo !== false">
                                    <a :href="storage_url + '/storage/' + row.arquivo.file" title="Abrir Arquivo" target="_blank"><i class="fas fa-eye"></i></a>
                                  </div>
                                  <div class="" v-show="row.contabilizar == 0">
                                    <i class="fas fa-not-equal" style="opacity: 0.3"></i>
                                  </div>
                                </td>
                              </template>

                          </base-table>
                        </template>
                      </div>

                      <template v-if="!loading">
                        <div class="protetico">
                          <div class="protetico__box">
                            <h1 class="protetico__head">
                              Saldo Geral:
                            </h1>

                            <ul class="protetico__data">
                              <li>Dentista: <strong>{{ dentista.nome }}</strong></li>
                              <li>Saldo Devedor Total: <strong>R$ {{ saldo.toLocaleString('pt-br', {minimumFractionDigits: 2}) }}</strong></li>
                            </ul>

                            <h4 class="protetico__head" style="margin-top: 40px">
                              Pendentes Selecionados x Pagos Selecionados:
                            </h4>

                            <ul class="protetico__data">
                              <li>Valores Pendentes: <strong>R$ {{ valor_pendente.toLocaleString('pt-br', {minimumFractionDigits: 2}) }}</strong></li>
                              <li>Valores Pagos: <strong>R$ {{ valor_pago.toLocaleString('pt-br', {minimumFractionDigits: 2}) }}</strong></li>
                            </ul>
                          </div>

                          <div class="protetico__box">
                               <div class="row">
                                <div class="col-12 col-lg-4">
                                    <base-input alternative=""
                                        label="Valor a Pagar: (pressione enter)"
                                        input-classes="form-control-alternative"
                                        v-model="valor_a_pagar"
                                        @keypress.enter="handleValorPagar(valor_a_pagar)"
                                    />
                                </div>
                            </div>

                            <div class="uploader">
                              <label>
                                  <i class="ni ni-cloud-upload-96" />
                                  <span>Selecionar Comprovante</span>
                                  <input type="file" @change="processFiles" />
                              </label>

                              <ul class="uploader-list">
                                  <li v-for="(file, k) in filesArray" :key="k">{{file.name}}</li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </template>

                       <template v-if="loading">
                          <div class="m-2">
                            <skeleton altura="60px" :velocidade="2.2" :atraso="0.2" :itens="1" classItem="mb-2"></skeleton>
                          </div>
                        </template>

                        <div slot="footer" class="caseSalvar d-center flex-row p-1 no-print mt-4 mb-4" v-if="!loading">
                          <base-button type="warning" @click="imprimir3()">Imprimir Relatório</base-button>
                          <base-button type="default" @click="uploadPagamento()" v-show="user.tipo === 'lab'">Salvar Pagamento</base-button>
                        </div>

                        <div class="erro" v-show="hasError">
                          <p>Houve um erro ao salvar seu comprovante, verifique o seu arquivo.</p>
                        </div>


                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
  import ordens from '@/cflow/ordens.js'
  import moment from 'moment';
  import BaseButton from '../../components/BaseButton.vue';
  //import BaseInput from '../../components/BaseInput.vue';
  //import Multiselect from "vue-multiselect";
  import storage from 'storage';
  //import router from '@/router'
  export default {
    name: 'tables',
    components: {
     // Multiselect,
      BaseButton,
     // BaseInput
    },
    methods: {
      uploadPagamento() {

        const _this = this;
        const idxs = _this.$route.params.idxs;
        const files = _this.filesArray;
        const form = _this.formData;

        _this.hasError = false;
        _this.loading = true;

        ordens.upload2(files).then( files_path => {

          if(files_path.data && files_path.data.length > 0) {
            form.arquivos = files_path.data;
          }

          let metaForm = [];
          _this.listaDados.forEach(item => {
            let { id: idOrdem, idLaboratorio, valores: valor_total, valor_pago, valor_pendente } = item;
            metaForm.push({
              idOrdem,
              idLaboratorio,
              valor_total,
              valor_pago,
              valor_pendente
            })
          });

          form.metaForm = metaForm;
          form.dentista = _this.dentista.nome;
          form.id_lab = _this.user.id;

          ordens.salvarPagamento(idxs, form).then(() => {
            //router.push('/relatorio-solicitacoes);
            _this.listaDados = [];
            _this.initLoad(0);
          }).catch(err => {
            console.err('UPLOAD ERROR ==>', err);
            _this.hasError = true;
            _this.loading = false;
          })

        })


      },
      processFiles: function(event) {
      var files = event?.target?.files;
 
      if(files && files.length > 0) {
        this.filesArray = files;
      }
 
    },
      initLoad: function(print = false) {
        this.loading = true;
        const idxs = this.$route.params.idxs;
        Promise.all([ordens.listarServicosParaPagar(idxs, print)]).then( res => {

          if(print === true) {
            var width = 595; // largura em pixels para A4 (210mm)
            var height = 842; // altura em pixels para A4 (297mm)
            var left = (screen.width / 2) - (width / 2);
            var top = (screen.height / 2) - (height / 2);

            var winBox = window.open('', 'CenteredWindow', 'width=' + width + ', height=' + height + ', top=' + top + ', left=' + left);
            winBox.document.write(res);
            winBox.document.close();

            this.loading = false;
          } else {
            console.log('res', res)
            this.saldo = res[0].saldo;
            this.listaDados = this.listaDados.concat(res[0].ordem);
            this.dentista = this.listaDados[0].dentista;
            this.saldo_anterior = this.listaDados[0].saldo_anterior || 0;
            const _this = this;
            this.listaDados.forEach(item => {
              if(item.valores) {
                  _this.valor_total += item.valores;
              }
              if(item.valor_pago) {
                  _this.valor_pago += item.valor_pago;
              }
              if(item.valor_pendente) {
                  _this.valor_pendente += item.valor_pendente;
              }
            })
            this.loading = false;
          }
        })
      },
      handleValorPagar(value) {
        const _this = this;
        const valued = parseFloat(value.replace(',', '.'));
      
        if (valued > _this.valor_pendente) return;
      
        let totalPendente = _this.listaDados.reduce((sum, item) => sum + item.valor_pendente, 0);
        let restValue = valued;
      
        _this.listaDados.forEach(item => {
          if (item.valor_pendente > 0) {
            const proporcao = item.valor_pendente / totalPendente;
            let abatimento = Math.min(proporcao * valued, item.valor_pendente);
            abatimento = Math.round(abatimento * 100) / 100; // Arredonda para 2 casas decimais
      
            item.valor_pendente -= abatimento;
            item.valor_pago += abatimento;
            restValue -= abatimento;
          }
        });
      
        // Distribui qualquer valor restante devido a arredondamentos
        if (restValue > 0) {
          for (let item of _this.listaDados) {
            if (item.valor_pendente > 0) {
              let abatimento = Math.min(restValue, item.valor_pendente);
              abatimento = Math.round(abatimento * 100) / 100;
              
              item.valor_pendente -= abatimento;
              item.valor_pago += abatimento;
              restValue -= abatimento;
      
              if (restValue <= 0) break;
            }
          }
        }
      
        _this.valor_a_pagar = '';
        
        // Atualiza os totais
        _this.valor_pago = _this.listaDados.reduce((sum, item) => sum + item.valor_pago, 0);
        _this.valor_pendente = _this.listaDados.reduce((sum, item) => sum + item.valor_pendente, 0);
      },
      agruparServicos(servicos) {
        const agrupados = {};

        servicos.forEach(servico => {
          const chave = `${servico.nome}_${servico.value}`;
          if (!agrupados[chave]) {
            agrupados[chave] = {
              nome: servico.nome,
              valor: servico.value,
              qtd: 1
            };
          } else {
            agrupados[chave].qtd++;
          }
        });

        return Object.values(agrupados);
      },
      imprimir3() {
        this.initLoad(true);
      }
    },
    watch: {
      
    },
    data() {
      return {
        loading: false,
        user: {},
        listaDados:[],
        dentista: {},
        valor_total: 0,
        valor_pago: 0,
        valor_pendente: 0,
        filesArray: [],
        formData: {
          arquivos: null,
          protetico: null,
          total: null,
          id_lab: null
        },
        valor_a_pagar: '',
        saldo_anterior: 0,
        saldo: 0,
        today: moment().format('YYYY-MM-DD'),
        hasError: false,
        storage_url: ''
      }
    },
    mounted(){
      this.user = storage.get("user");
      this.initLoad(0);
    }
  };
</script>
<style lang="scss" scoped>
.protetico {
  padding: 20px 20px;
  margin: 20px 20px;
  border: 1px solid #ccc;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.protetico__box {
  width: 50%;
}
.protetico__name {
  font-size: 16px;
}
.protetico__data {
  list-style: none;
  padding: 0;
}
.protetico__data li {
  font-size: 12px;
}
.protetico__data li strong {
  font-size: 14px;
}

@media all and (max-width: 630px) {
  .protetico {
    flex-direction: column;
  }
  .protetico__box {
    width: 100%;
    padding: 20px 0;
  }
}

.files {
  padding: 40px 0;
}
.uploader input {
  display: none;
}
.uploader label {
  cursor: pointer;
  text-align: center;
  border: 2px solid #525f7f;
  border-radius: 10px;
  padding: 10px 0;
  opacity: 0.8;
}
.uploader label:hover {
  opacity: 1;
}
.uploader i {
  width: 100%;
  font-size: 42px;
}
.uploader span {
  font-size: 14px;
  text-transform: uppercase;
}
.uploader-list {
  margin: 20px 0 0 0;
}

.erro {
  padding: 20px;
  font-size: 12px;
  text-transform: uppercase;
  color: red;
  text-align: center;
}

.fas {
  font-size: 16px;
  margin: 0 4px;
}

.subtable {
  width: 100%;
}

.subtable th, .subtable tr, .subtable td {
  padding: 3px;
}

.subtable td:nth-child(2) {
  text-align: right;
}

</style>
